export enum VpaApplicationRequestType {
  Transition = 'Transition',
  ClassicForSaleMarketing = 'ClassicForSaleMarketing',
  PndForSaleMarketing = 'PndForSaleMarketing',
  PndRentalMarketing = 'PndRentalMarketing',
  PndAgentContribution = 'PndAgentContribution',
  RentalLandlordPayment = 'RentalLandlordPayment',
  RentalTenantPayment = 'RentalTenantPayment'
}
